import { GameExperienceState } from '../common-types/GameExperienceState';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Game } from '../common-types/GlobalExperienceState.type';

const initialState: GameExperienceState = {
  currentCampaign: null,
  currentGameConfiguration: null,
  currentIndex: 0,
  currentTicket: null,
  hasWonCurrentGame: null,
};

export const gameExperienceSlice = createSlice({
  initialState,
  name: 'GameExperience',
  reducers: {
    setCurrentGameConfiguration (state: GameExperienceState, { payload }: PayloadAction<{ data: Game, index: number }>): GameExperienceState {
      return {
        currentCampaign: payload.data.campaign,
        currentGameConfiguration: payload.data.gameConfiguration,
        currentIndex: payload.index,
        currentTicket: payload.data.ticket,
        hasWonCurrentGame: null,
      };
    },
    setGameResult (state: GameExperienceState, { payload }: PayloadAction<boolean>): GameExperienceState {
      return {
        ...state,
        hasWonCurrentGame: payload,
      };
    },
  },
});

const { actions, reducer } = gameExperienceSlice;

export const { setCurrentGameConfiguration, setGameResult } = actions;
export default reducer;
